// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"42d6fef32db5d7aa2604","655":"0ca143b01830a5d0a2f5"}[chunkId] + ".js";
};